/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _module = __webpack_require__(1);
	
	var windowW = $(window).width();
	var windowH = $(window).innerHeight();
	
	// テスト
	var _isTest = false;
	
	var _isSP;
	var windowW = window.innerWidth;
	var prewidth = window.innerWidth;
	
	//preload
	
	(0, _module.preload)();
	
	//pageTop
	
	(0, _module.pageTop)();
	
	//showMovie
	
	(0, _module.showMovie)();
	
	//toggleHeader
	
	(0, _module.toggleHeader)();
	
	// //bgAnime
	// import {bgAnime} from "../include/module";
	// bgAnime();
	
	$(window).on('resize load', function () {
	  if (windowW <= 1024) {
	    _isSP = true;
	  } else {
	    _isSP = false;
	  };
	
	  //リサイズ処理 ブレイクポイントを跨いだらリロード
	  var nowWidth = window.innerWidth;
	  if (prewidth !== nowWidth) {
	    if (prewidth < 1025) {
	      if (nowWidth >= 1025) {
	        location.reload();
	      }
	    } else {
	      if (nowWidth < 1025) {
	        location.reload();
	      }
	    }
	  };
	});
	
	$(window).on('load', function () {
	  //アニメーション省略
	  if (_isTest) {} else {}
	
	  //バナー調整
	  if ($(".index-Bnr_Item").length == 1) {
	    $('.index-Bnr').addClass("index-Bnr_List-1");
	  } else if ($(".index-Bnr_Item").length == 2) {
	    $('.index-Bnr').addClass("index-Bnr_List-2");
	  } else if ($(".index-Bnr_Item").length == 3) {
	    $('.index-Bnr').addClass("index-Bnr_List-3");
	  };
	
	  setTimeout(function () {
	    $('#index-Loader').addClass("load");
	  }, 0);
	  setTimeout(function () {
	    $('#index-Loader').addClass("hidden");
	  }, 1500);
	  setTimeout(function () {
	    $('#index-Loader').remove();
	  }, 3600);
	
	  setTimeout(function () {
	    mainAnime();
	  }, 1600);
	
	  bgStar();
	  bnrSlide();
	  scrollIndexAnime();
	});
	
	// ------------------------------------------------------------------------
	// mainAnime
	// ----- BOTH
	// ------------------------------------------------------------------------
	var mainAnime = function mainAnime() {
	
	  setTimeout(function () {
	    $('.js-loadingAnimation').addClass("is-animated");
	  }, 0);
	};
	
	// ------------------------------------------------------------------------
	// bgStar
	// ----- BOTH
	// ------------------------------------------------------------------------
	var bgStar = function bgStar() {
	  particlesJS("bg_Star", { "particles": { "number": { "value": 20, "density": { "enable": true, "value_area": 800 } }, "color": { "value": "#003555" }, "shape": { "type": "circle", "stroke": { "width": 0, "color": "#000000" }, "polygon": { "nb_sides": 5 }, "image": { "src": "img/github.svg", "width": 100, "height": 100 } }, "opacity": { "value": 0.2, "random": true, "anim": { "enable": true, "speed": .5, "opacity_min": 0, "sync": false } }, "size": { "value": 2.5, "random": true, "anim": { "enable": false, "speed": 40, "size_min": 10, "sync": true } }, "line_linked": { "enable": false, "distance": 150, "color": "#ffffff", "opacity": 0.2, "width": 1 }, "move": { "enable": true, "speed": 0.1, "direction": "none", "random": true, "straight": false, "out_mode": "bounce", "bounce": false, "attract": { "enable": false, "rotateX": 600, "rotateY": 600 } } }, "interactivity": { "detect_on": "canvas", "events": { "onhover": { "enable": false, "mode": "repulse" }, "onclick": { "enable": false, "mode": "repulse" }, "resize": true }, "modes": { "grab": { "distance": 400, "line_linked": { "opacity": 1 } }, "bubble": { "distance": 250, "size": 0, "duration": 2, "opacity": 0, "speed": 3 }, "repulse": { "distance": 400, "duration": 0.4 }, "push": { "particles_nb": 4 }, "remove": { "particles_nb": 2 } } }, "retina_detect": true });
	};
	
	// ------------------------------------------------------------------------
	// scrollIndexAnime
	// ----- BOTH
	// ------------------------------------------------------------------------
	var scrollIndexAnime = function scrollIndexAnime() {
	
	  var endHeight = document.querySelector('.st-Container').offsetHeight;
	
	  // ページトップ
	  gsap.to('.st-Container', {
	    scrollTrigger: {
	      trigger: '.st-Container',
	      start: '+=80px top',
	      end: 'bottom top',
	      toggleClass: { targets: "#st-Top", className: "st-Top-Show" }
	    }
	  });
	
	  // ヘッダーロゴ
	  gsap.to('.st-Container', {
	    scrollTrigger: {
	      trigger: '#index-Keyvisual',
	      start: '+=20px top',
	      end: function end() {
	        return '+=' + endHeight;
	      },
	      toggleClass: { targets: "#st-Header", className: "st-Header-Shorten" }
	      // markers: true // 検証用のマーカーを表示
	    }
	  });
	
	  if (!_isSP) {
	    // 星背景
	    gsap.to('.st-Bg-shooting_star-l', {
	      // onStart:myFunc,
	      backgroundPosition: "-20000px 8000px",
	      scrollTrigger: {
	        trigger: '.st-Container',
	        start: 'top top',
	        end: '+=55999px top',
	        // end: () => '+=' + endHeight,
	        // end: '+=120px top',
	        // end:,
	        scrub: true //スクロールバーに直接リンクさせて動作させる
	        // markers: true // 検証用のマーカーを表示
	      }
	    });
	
	    // 星背景
	    gsap.to('.st-Bg-shooting_star-r', {
	      backgroundPosition: "-20000px 8000px",
	      scrollTrigger: {
	        trigger: '.st-Container',
	        start: 'top top',
	        end: '+=55999px top',
	        scrub: true
	        // markers: true // 検証用のマーカーを表示
	      }
	    });
	    // function myFunc(){
	    //   console.log( "finished" );
	    // }
	  } else {
	      // // 星背景
	      // gsap.to('.st-Bg-shooting_star-l', {
	      //   // onStart:myFunc,
	      //   backgroundPosition: "-10000px 4000px",
	      //   scrollTrigger: {
	      //     trigger: '.st-Container',
	      //     start: 'top top',
	      //     end: '+=55999px top',
	      //     // end: () => '+=' + endHeight,
	      //     // end: '+=120px top',
	      //     // end:,
	      //     scrub: true,　//スクロールバーに直接リンクさせて動作させる
	      //     // markers: true // 検証用のマーカーを表示
	      //   }
	      // });
	
	      // // 星背景
	      // gsap.to('.st-Bg-shooting_star-r', {
	      //   backgroundPosition: "-10000px 4000px",
	      //   scrollTrigger: {
	      //     trigger: '.st-Container',
	      //     start: 'top top',
	      //     end: '+=55999px top',
	      //     scrub: true,
	      //     // markers: true // 検証用のマーカーを表示
	      //   }
	      // });
	    }
	
	  if (!_isSP) {
	    // KV
	    gsap.to('#index-Keyvisual_Img_Item', {
	      y: '12%',
	      // opacity:0.7,
	      scrollTrigger: {
	        trigger: '.index-Keyvisual_Wrapper',
	        start: 'top top',
	        end: 'bottom top',
	        // end: () => '+=' + document.querySelector('.index-Keyvisual_Wrapper').offsetHeight,
	        scrub: true
	        // markers: true // 検証用のマーカーを表示
	      }
	    });
	  }
	
	  // const tl = gsap.timeline({
	  //   scrollTrigger: {
	  //     trigger: "#index-Keyvisual_Wrapper",
	  //     start: "top top",
	  //     end: "bottom top",
	  //     scrub: true
	  //   }
	  // });
	
	  // gsap.utils.toArray("#index-Keyvisual_Img_Item").forEach(layer => {
	  //   const depth = layer.dataset.depth;
	  //   const movement = -(layer.offsetHeight * depth)
	  //   tl.to(layer, {y: -movement, ease: "none"}, 0)
	  // });
	
	  // メニュ-
	  gsap.to('#st-Menu', {
	    scrollTrigger: {
	      trigger: '#index-Keyvisual',
	      start: 'bottom top',
	      end: function end() {
	        return '+=' + endHeight;
	      },
	      toggleClass: { targets: "#st-Menu", className: "st-Menu-Show" }
	      // markers: true // 検証用のマーカーを表示
	    }
	  });
	
	  // メニュ-2
	  gsap.to('#st-Menu', {
	    scrollTrigger: {
	      trigger: '#index-Keyvisual',
	      start: '+=20px top',
	      end: function end() {
	        return '+=' + endHeight;
	      },
	      toggleClass: { targets: "#st-Menu", className: "st-Menu-Display" }
	      // markers: true // 検証用のマーカーを表示
	    }
	  });
	
	  if (!_isSP) {
	    //　スクロールで発火系
	    var targets = document.querySelectorAll(".js-scrollAnimation");
	    var targetsArray = Array.prototype.slice.call(targets); //Array
	    targetsArray.forEach(function (target) {
	      //シーンを作成
	      ScrollTrigger.create({
	        trigger: target, //アニメーションが始まるトリガーとなる要素
	        start: 'top 95%',
	        end: function end() {
	          return '+=' + endHeight;
	        },
	        toggleClass: { targets: target, className: "is-animated" }
	        // markers: true, // 検証用のマーカーを表示
	      });
	    });
	  } else {
	    //　スクロールで発火系
	    var _targets = document.querySelectorAll(".js-scrollAnimation");
	    var _targetsArray = Array.prototype.slice.call(_targets); //Array
	    _targetsArray.forEach(function (target) {
	      //シーンを作成
	      ScrollTrigger.create({
	        trigger: target, //アニメーションが始まるトリガーとなる要素
	        start: 'top bottom',
	        end: function end() {
	          return '+=' + endHeight;
	        },
	        toggleClass: { targets: target, className: "is-animated" }
	        // markers: true, // 検証用のマーカーを表示
	      });
	    });
	  }
	
	  // // トリガー取得
	  // const scrollTrigger = document.querySelectorAll('.js-scrollAnimation');
	
	  // // aimation呼び出し
	  // if (scrollTrigger.length) {
	  //     scrollAnimation(scrollTrigger);
	  // }
	
	  // // aimation関数
	  // function scrollAnimation(trigger) {
	  //     window.addEventListener('scroll', function () {
	  //         for (var i = 0; i < trigger.length; i++) {
	  //             let position = trigger[i].getBoundingClientRect().top,
	  //                 scroll = window.pageYOffset || document.documentElement.scrollTop,
	  //                 offset = position + scroll,
	  //                 windowHeight = window.innerHeight;
	
	  //             if (scroll > offset - windowHeight + 200) {
	  //                 trigger[i].classList.add('is-active');
	  //             }
	  //         }
	  //     });
	  // }
	
	
	  // const controller = new ScrollMagic.Controller();
	
	  // //ページトップ出現
	  // const scene = new ScrollMagic.Scene({
	  //   // triggerElement:'#index-Contents',
	  //   triggerHook: 1,
	  //   offset: '80'
	  // })
	  // .setClassToggle('#st-Top', 'st-Top-Show')
	  // .addTo(controller);
	
	  // //ヘッダー
	  // new ScrollMagic.Scene({
	  //   triggerHook: 1,
	  //   offset: '120'
	  // })
	  // .setClassToggle("#st-Header", "st-Header-Shorten")
	  // .addTo(controller);
	
	
	  // //背景
	  // new ScrollMagic.Scene({
	  //   triggerElement: '.st-Container',
	  //   triggerHook: 1,
	  //   duration: $('.st-Container').innerHeight(),
	  //         // duration: "200%"
	  // })
	  // .on("progress", function (prog) { // 使いたいシーンに対してprogressイベントを設定します
	  //   var p = prog.progress; // 0～1の値が入ってきます
	  //   anime({
	  //     targets:".st-Bg-shooting_star-l",
	  //     backgroundPositionY: (8 * p) * 100 + "px",
	  //     backgroundPositionX: -(20 * p) * 100 + "px",
	  //     easing: 'easeOutCubic',
	  //     duration: 10,
	  //     elasticity: 0
	  //   });
	  //   anime({
	  //     targets:".st-Bg-shooting_star-r",
	  //     backgroundPositionY: (8 * p) * 100 + "px",
	  //     backgroundPositionX: -(20 * p) * 100 + "px",
	  //     easing: 'easeOutCubic',
	  //     duration: 10,
	  //     elasticity: 0
	  //   });
	  // })
	  // // .addIndicators({name: "1"})
	  // .addTo(controller);
	
	  // //KV
	  // new ScrollMagic.Scene({
	  //   triggerElement: '#index-Keyvisual',
	  //   triggerHook: 0,
	  //   duration: "100%",
	  // })
	  // .on("progress", function (prog) { // 使いたいシーンに対してprogressイベントを設定します
	  //   var p = prog.progress; // 0～1の値が入ってきます
	  //   anime({
	  //     targets:"#index-Keyvisual_Img_Item",
	  //     translateY: (1.2 * p) * 100,
	  //     easing: 'easeOutCubic',
	  //     duration: 180,
	  //     elasticity: 0
	  //   });
	  // })
	  // // .addIndicators({name: "1"})
	  // .addTo(controller);
	
	  // //　スクロールで発火系
	  // const targets = document.querySelectorAll(".js-scrollAnimation");
	  // const targetsArray = Array.prototype.slice.call(targets); //Array
	  // targetsArray.forEach(target => {
	  //   //シーンを作成
	  //   new ScrollMagic.Scene({
	  //       triggerElement: target,
	  //       triggerHook: 1
	  //   })
	  //   .setClassToggle(target, "is-animated")
	  //   .addTo(controller);
	  // });
	};
	
	// ------------------------------------------------------------------------
	// bnrSlide
	// ----- BOTH
	// ------------------------------------------------------------------------
	var bnrSlide = function bnrSlide() {
	
	  var bnrSwiper;
	  var options = {};
	
	  //1枚の時
	  if ($(".index-Bnr_Item").length == 1) {
	    options = {
	      autoHeight: false,
	      slidesPerView: 3,
	      spaceBetween: 15,
	      centeredSlides: true,
	      loop: false,
	      grabCursor: true,
	      watchOverflow: true, //スライドの枚数がスライダー生成の条件に満たさない時）、コントロール関係を削除してスライド機能もなくす。
	      navigation: {
	        nextEl: '.index-Bnr_Button_Next',
	        prevEl: '.index-Bnr_Button_Prev',
	        hideOnClick: true
	      },
	      // on: {
	      //   init: function () {
	      //     $('.index-Bnr').addClass("index-Bnr_List-1");
	      //   },
	      // },
	      breakpoints: {
	        1024: {
	          slidesPerView: 1.1,
	          loop: false,
	          spaceBetween: 0
	        }
	      }
	    };
	  } else if ($(".index-Bnr_Item").length == 2) {
	    //2枚の時
	    options = {
	      autoHeight: false,
	      slidesPerView: 2,
	      spaceBetween: 15,
	      // centeredSlides: true,
	      loop: false,
	      loopAdditionalSlides: 1, //一瞬の途切れがなくなり、2周目以降も途切れることなくループできる
	      grabCursor: true,
	      watchOverflow: true, //スライドの枚数がスライダー生成の条件に満たさない時）、コントロール関係を削除してスライド機能もなくす。
	      // width: 715,
	      navigation: {
	        nextEl: '.index-Bnr_Button_Next',
	        prevEl: '.index-Bnr_Button_Prev',
	        hideOnClick: true
	      },
	      // on: {
	      //   init: function () {
	      //     $('.index-Bnr').addClass("index-Bnr_List-2");
	      //   },
	      // },
	      breakpoints: {
	        1024: {
	          slidesPerView: 1.1,
	          loop: false,
	          spaceBetween: 0,
	          pagination: {
	            el: '.index-Bnr_Pagenation',
	            clickable: true
	          }
	        }
	      }
	    };
	  } else if ($(".index-Bnr_Item").length == 3) {
	    //3枚の時
	    options = {
	      autoHeight: false,
	      slidesPerView: 3,
	      spaceBetween: 15,
	      // centeredSlides: true,
	      loop: false,
	      loopAdditionalSlides: 1, //一瞬の途切れがなくなり、2周目以降も途切れることなくループできる
	      grabCursor: true,
	      watchOverflow: true, //スライドの枚数がスライダー生成の条件に満たさない時）、コントロール関係を削除してスライド機能もなくす。
	      // width: 715,
	      navigation: {
	        nextEl: '.index-Bnr_Button_Next',
	        prevEl: '.index-Bnr_Button_Prev',
	        hideOnClick: true
	      },
	      // on: {
	      //   init: function () {
	      //     $('.index-Bnr').addClass("index-Bnr_List-3");
	      //   },
	      // },
	      breakpoints: {
	        1024: {
	          slidesPerView: 1.1,
	          loop: false,
	          spaceBetween: 0,
	          pagination: {
	            el: '.index-Bnr_Pagenation',
	            clickable: true
	          }
	        }
	      }
	    };
	  } else {
	    //4枚以上の時
	    options = {
	      autoHeight: false,
	      slidesPerView: 3,
	      spaceBetween: 15,
	      loop: true,
	      loopAdditionalSlides: 1, //一瞬の途切れがなくなり、2周目以降も途切れることなくループできる
	      grabCursor: true,
	      watchOverflow: true, //スライドの枚数がスライダー生成の条件に満たさない時）、コントロール関係を削除してスライド機能もなくす。
	      autoplay: {
	        delay: 4000,
	        disableOnInteraction: true // ユーザーのスワイプ操作を検出したら自動再生を中止するか
	      },
	      speed: 800,
	      pagination: {
	        el: '.index-Bnr_Pagenation',
	        clickable: true
	      },
	      navigation: {
	        nextEl: '.index-Bnr_Button_Next',
	        prevEl: '.index-Bnr_Button_Prev',
	        hideOnClick: true
	      },
	      breakpoints: {
	        1024: {
	          slidesPerView: 1.1,
	          loop: false,
	          spaceBetween: 0,
	          autoplay: {
	            delay: 4000,
	            disableOnInteraction: true // ユーザーのスワイプ操作を検出したら自動再生を中止するか
	          }
	        }
	      }
	    };
	  }
	
	  bnrSwiper = new Swiper('.index-Bnr_Box', options);
	
	  if ($(".index-Bnr_Item").length == 0) {} else {
	    if (!_isSP) {
	      bnrSwiper.autoplay.start();
	    } else {
	      bnrSwiper.autoplay.stop();
	    };
	  }
	};

/***/ }),
/* 1 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var headerFlag = false;
	var stHeader = document.getElementById('st-Header');
	var stHeaderNav = document.getElementById('st-Header_Nav');
	var stHeaderBg = document.getElementById('st-Header_Bg');
	var headerButton = document.getElementById('st-Menu');
	var _isSP = false;
	
	// checkSP
	var checkSP = function checkSP() {
	  $(window).on('resize load', function () {
	    windowW = $(window).width();
	    if (windowW <= 1024) {
	      _isSP = true;
	    } else {
	      _isSP = false;
	    };
	  });
	};
	
	// ------------------------------------------------------------------------
	// preload
	// ----- BOTH
	// ------------------------------------------------------------------------
	var preload = function preload() {
	
	  history.replaceState(null, null, null);
	  window.addEventListener('popstate', function () {
	
	    $('body').addClass('preload');
	
	    headerFlag = false;
	    stHeaderNav.classList.remove('opened');
	    headerButton.classList.remove('opened');
	    stHeaderBg.classList.remove('opened');
	    stHeaderLogo.classList.remove('opened');
	    stHeaderNav.classList.add('closed');
	    headerButton.classList.add('closed');
	    stHeaderBg.classList.add('closed');
	    stHeaderLogo.classList.add('closed');
	
	    setTimeout(function () {
	      $('body').removeClass('preload');
	    }, 100);
	  }, false);
	
	  $(window).on('load', function () {
	    $("body").removeClass("preload");
	  });
	};
	
	// ------------------------------------------------------------------------
	// toggleHeader
	// ----- BOTH
	// ------------------------------------------------------------------------
	var toggleHeader = function toggleHeader() {
	
	  headerButton.addEventListener('click', function () {
	
	    if (!headerFlag) {
	      // $('#st-Header_Navi').css({'display':'block'});
	      setTimeout(function () {
	        stHeader.classList.remove('closed');
	        stHeaderNav.classList.remove('closed');
	        headerButton.classList.remove('closed');
	        stHeaderBg.classList.remove('closed');
	        stHeader.classList.add('opened');
	        stHeaderNav.classList.add('opened');
	        headerButton.classList.add('opened');
	        stHeaderBg.classList.add('opened');
	        headerFlag = true;
	      }, 0);
	    } else {
	      stHeader.classList.remove('opened');
	      stHeaderNav.classList.remove('opened');
	      headerButton.classList.remove('opened');
	      stHeaderBg.classList.remove('opened');
	      stHeader.classList.add('closed');
	      stHeaderNav.classList.add('closed');
	      headerButton.classList.add('closed');
	      stHeaderBg.classList.add('closed');
	      headerFlag = false;
	      // setTimeout(function(){
	      //   // $('#st-Header_Navi').css({'display':'none'});
	      // },0);
	    }
	  }, false);
	};
	
	// ------------------------------------------------------------------------
	// pageTop
	// ----- BOTH
	// ------------------------------------------------------------------------
	var pageTop = function pageTop() {
	
	  $("#st-Top").on("click", function () {
	    var linkSpeed = 800;
	    $("html, body").animate({ scrollTop: 0 }, linkSpeed, "easeOutExpo");
	    return false;
	  });
	};
	
	// ------------------------------------------------------------------------
	// showMovie
	// ----- BOTH
	// ------------------------------------------------------------------------
	var showMovie = function showMovie() {
	  var $modal = $('#sw-Youtube');
	  var $content = $('#sw-Youtube_Content');
	
	  // open
	  $('.js-Youtube').on('click', function () {
	
	    var dataID = $(this).attr('data-youtube');
	
	    $('#sw-Youtube').css({ 'opacity': '0', 'display': 'block' }).stop().animate({ 'opacity': '1', 'width': 100 + '%', 'height': 100 + 'vh', 'top': 0, 'left': 0 }, 500, 'easeOutQuart', function () {
	      //iframe append
	      $content.append('<iframe width="900" height="506" src="https://www.youtube.com/embed/' + dataID + '?rel=0&amp;autoplay=1" frameborder="0" allow="autoplay; encrypted-media" allowfullscreen" frameborder="0"></iframe>');
	      // fadeIn
	      $modal.stop().fadeIn(400);
	      return false;
	    });
	  });
	
	  //close
	  $('#sw-Youtube_Close,#sw-Youtube_Overlay').on('click', function () {
	
	    $('#sw-Youtube').css({ 'opacity': '1' }).stop().animate({ 'opacity': '0' }, 500, 'easeOutQuart', function () {
	      $('#sw-Youtube').css({ 'display': 'none' });
	      $content.children('iframe').remove();
	    });
	  });
	};
	
	// ------------------------------------------------------------------------
	// anchorLink
	// ----- BOTH
	// ------------------------------------------------------------------------
	var anchorLink = function anchorLink() {
	
	  //ページ外からのページ内リンク
	  var urlHash = location.hash;
	  if (urlHash) {
	    $('body,html').stop().scrollTop(0);
	    setTimeout(function () {
	      var target = $(urlHash);
	      var position = target.offset().top - 80;
	      $('body,html').stop().animate({ scrollTop: position }, 500);
	    }, 200);
	  }
	
	  var linkSpeed = 1000;
	  var linkAdjust = 50;
	
	  //ページ内リンク
	  $("a[href^='#']").on("click", function () {
	
	    var linkHref = $(this).attr("href");
	    var linkTarget = $(linkHref == "#" || linkHref == "" ? 'html' : linkHref);
	    var linkPosition = linkTarget.offset().top;
	
	    $("html, body").animate({ scrollTop: linkPosition - linkAdjust }, linkSpeed, "easeInOutQuint");
	    return false;
	  });
	};
	
	// // bgAnime
	// const bgAnime = () => {
	//   let bgBox = $(".st-Bg-shooting_star-l");
	//   var positionBg = 0; //初期値を取得
	
	//   //横幅のリサイズだけ検出
	//   var lastInnerWidth = window.innerWidth ;
	//   window.addEventListener( "resize", function () {
	
	//     // 現在と前回の横幅が違う場合だけ実行
	//     if ( lastInnerWidth != window.innerWidth ) {
	//       bgBox.css('top', '');
	//       positionBg = 0; //初期値を取得
	//       // 横幅を記録しておく
	//       lastInnerWidth = window.innerWidth;
	//     }
	//   }) ;
	
	
	//   $(window).on("scroll load", function(){
	//     var value = $(this).scrollTop();
	//     var h = $(window).height();
	//     if(_isSP){
	//         bgBox.css('backgroundPosition', -value / 200);
	//     } else {
	//         bgBox.css({
	//           backgroundPositionX: '-value / 200',
	//           backgroundPositionY: '-value / 80',
	//         });
	//     };
	//   });
	// };
	
	
	exports.preload = preload;
	exports.toggleHeader = toggleHeader;
	exports.pageTop = pageTop;
	exports.showMovie = showMovie;
	exports.anchorLink = anchorLink;

/***/ })
/******/ ]);


// WEBPACK FOOTER //
// index/app.bundle.js